<div class="w9-agent-panel">
  <member-w9-agent-panel-header
    [activeTab]="activeTab()"
    (tabChange)="onTabChange($event)"
  />

  @if (activeTab() === 'chat') {
    <div class="w9-agent-panel__body" #scrollEl>
      <member-w9-desk-brief-welcome [firstName]="providerFirstName" [tinType]="tinType" />
      @for (m of visibleMessages(); track m.id) {
        <member-w9-agent-message-row [message]="m" [providerInitials]="providerInitials()" />
      }
      @if (sendError()) {
        <div class="w9-agent-panel__error" role="alert">Couldn't send — try again.</div>
      }
    </div>
    <member-w9-agent-composer
      [value]="input()"
      (valueChange)="input.set($event)"
      (send)="onSend($event)"
    />
  } @else {
    <div class="w9-agent-panel__body">
      <member-w9-task-list />
    </div>
  }
</div>
